<div *ngIf="loginAttempt && showLoginAttempts">
  <div>{{ "LABELS.LAST_LOGIN_ATTEMPT" | translate }}:</div>
  <div>
    <a [routerLink]="['/user', 'update']" [queryParams]="{ section: 'login-attempts-info-section' }">
      {{ loginAttempt.timestamp | customDateTimeByUtc }} - {{ "LABELS.IP" | translate }}: {{ loginAttempt.ipAddress }}
    </a>
  </div>
  <div class="text-wrap">
    {{ "LOGIN_ATTEMPT.IF_YOU_THINK_IT_WAS_NOT_YOU" | translate }}
    <br />
    <a href="#" (click)="contactSupport($event)">{{ "BUTTON.CONTACT_US" | translate }}</a>
    {{ "LOGIN_ATTEMPT.AND" | translate }}
    <a [routerLink]="['/auth', 'login']" [queryParams]="{ forgotPassword: 'true' }">{{ "LOGIN_ATTEMPT.RESET_PASSWORD" | translate }}</a>
  </div>
</div>
